import { useTranslation } from 'next-i18next';
import { FC, useMemo } from 'react';

import { WhatToSeeCard } from '@/components/WhatToSeeCard';
import { IWhatToSeeCardData, whatToSeeCardsData } from '@/components/WhatToSeeCard/whatToSeeCardsData';
import { COMMON_LOCALE_PART } from '@/locale';
import { SiteMenuItem } from '@/types';

interface IWhatToSeeProps {
  siteMenu: SiteMenuItem[];
}

export const WhatToSee: FC<IWhatToSeeProps> = ({ siteMenu }) => {
  const { t } = useTranslation(COMMON_LOCALE_PART);

  const cardsData = useMemo<IWhatToSeeCardData[]>(
    () =>
      whatToSeeCardsData.map((data) => {
        const menuItem = siteMenu.flatMap(({ dropdown }) => dropdown).find(({ name }) => name === t(data.titleKey));

        return { ...data, page_slug: menuItem?.page_slug };
      }),
    [siteMenu, t],
  );

  return (
    <section className="container">
      <h2 className="mb-6">{t('what-to-see.heading')}</h2>

      <p className="mb-6">{t('what-to-see.description')}</p>
      <p className="mb-3">{t('what-to-see.sections-description')}</p>

      <div className="grid grid-cols-6 gap-4">
        {cardsData.map((cardData) => (
          <WhatToSeeCard key={cardData.cardKey} cardData={cardData} />
        ))}
      </div>
    </section>
  );
};
